module.exports = __webpack_public_path__ + "static/img/4bg_3.1a46d5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/4bg_3.png
// module id = 705
// module chunks = 1